import React, { useMemo } from 'react';
import { MessageCircle } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import { useSiteSettings } from '../hooks/use-site-settings';

const normalizeWhatsappNumber = (value) => {
  return String(value || '').replace(/\D/g, '');
};

const buildWhatsappUrl = (rawNumber, rawMessage) => {
  const number = normalizeWhatsappNumber(rawNumber);
  if (!number) {
    return '';
  }

  const query = new URLSearchParams();
  const message = String(rawMessage || '').trim();
  if (message) {
    query.set('text', message);
  }

  const queryString = query.toString();
  return `https://wa.me/${number}${queryString ? `?${queryString}` : ''}`;
};

const FloatingWhatsAppButton = () => {
  const { siteSettings } = useSiteSettings();
  const location = useLocation();

  const whatsappUrl = useMemo(
    () => buildWhatsappUrl(siteSettings.whatsappNumber, siteSettings.whatsappMessage),
    [siteSettings.whatsappMessage, siteSettings.whatsappNumber],
  );

  if (location.pathname.startsWith('/admin')) {
    return null;
  }

  if (!whatsappUrl) {
    return null;
  }

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-40 inline-flex items-center gap-2 rounded-full bg-[#25D366] px-4 py-3 text-sm font-semibold text-white shadow-xl transition-transform hover:scale-105 hover:bg-[#1fb75a]"
      aria-label="Chat on WhatsApp"
      title="Chat on WhatsApp"
    >
      <MessageCircle className="h-5 w-5" />
      <span className="hidden sm:inline">WhatsApp</span>
    </a>
  );
};

export default FloatingWhatsAppButton;
